/** Desktop activity permission strings (mirror backend PermissionCatalog). */
export const DesktopActivityPermissions = {
  record: 'desktop_activity_record',
  review: 'desktop_activity_review',
  enroll: 'desktop_activity_enroll',
} as const
